import React, { Component } from "react";
import { connect } from "react-redux";
import {
  addNewOrder,
  apiSendSMSRequest,
  sendDriverSMS,
  sendCustomerSMS,
  selectCustomer,
} from "../../redux/actions";
import { css } from "react-emotion";
import { ClipLoader } from "react-spinners";
import { NotificationManager } from "react-notifications";
import { Card } from "components/Card/Card.jsx";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Table,
  Modal,
} from "react-bootstrap";

import _ from "lodash";

import Button from "components/CustomButton/CustomButton.jsx";
import Select from "react-select";
import { PersianNumber } from "@thg303/react-persian";

const mapStateToProps = (state) => {
  return {
    drivers: state.drivers,
    selectedCustomer: state.selectedCustomer,
    services: state.services,
    SendSMS: state.SendSMS,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addNewOrder: (customer, newOrder) =>
      dispatch(addNewOrder(customer, newOrder)),
    sendSMS: (payload) => dispatch(apiSendSMSRequest(payload)),
    sendDriverSMS: (payload) => dispatch(sendDriverSMS(payload)),
    sendCustomerSMS: (payload) => dispatch(sendCustomerSMS(payload)),
    selectCustomer: (customer) => {
      dispatch(selectCustomer(customer));
    },
  };
};

const override = css`
  display: block;
  margin: auto auto;
  border-color: red;
`;

class NewOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSaveOrder: false,
      canSendRequest: false,
      showDriverNotifyModal: false,
      selectedServiceCounter: 0,
      selectedServiceArea: 0,
      serviceTotalPrice: 0,
      selectAddress: {},
      selectDriver: {},
      selectAddressSendRequest: undefined,
      selectDriverSendRequest: undefined,
      selectService: {},
      invoice_number: 0,
      senfi_number: 0,
      transportation: 200000,
      order: {
        address: "",
        driver: {},
        services: [],
      },
      x: 0,
      y: 0,
      disabledServiceCount: true,
      addressOptions: this.generateOptionsFromAddresses(
        this.props.selectedCustomer.addresses
      ),
      serviceOptions: this.generateOptionsFromServices(this.props.services),
      driverOptions: this.generateOptionsFromDrivers(this.props.drivers),
    };

    this.createOrder = this.createOrder.bind(this);
    this.addThisService = this.addThisService.bind(this);
    this.saveOrderBtn = this.saveOrderBtn.bind(this);
    this.setAddress = this.setAddress.bind(this);
    this.changeCounter = this.changeCounter.bind(this);
    this.changeSenfiNumber = this.changeSenfiNumber.bind(this);
    this.changeInvoiceNumber = this.changeInvoiceNumber.bind(this);
    this.changeArea = this.changeArea.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangeDriver = this.handleChangeDriver.bind(this);
    this.handleChangeAddressSendRequest =
      this.handleChangeAddressSendRequest.bind(this);
    this.handleChangeDriverSendRequest =
      this.handleChangeDriverSendRequest.bind(this);
    this.handleChangeService = this.handleChangeService.bind(this);
    this.checkForCanSaveOrder = this.checkForCanSaveOrder.bind(this);
    this.generateOptionsFromAddresses =
      this.generateOptionsFromAddresses.bind(this);
    this.generateOptionsFromServices =
      this.generateOptionsFromServices.bind(this);
    this.generateOptionsFromDrivers =
      this.generateOptionsFromDrivers.bind(this);
    this.calculateAllServiceValues = this.calculateAllServiceValues.bind(this);
    this.changeTransportationValue = this.changeTransportationValue.bind(this);
    this.handleSendSMSSendRequestForDriver =
      this.handleSendSMSSendRequestForDriver.bind(this);
    this.removeService = this.removeService.bind(this);
    this.handleSendSMS = this.handleSendSMS.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.getRandom = this.getRandom.bind(this);
    this.changeX = this.changeX.bind(this);
    this.changeY = this.changeY.bind(this);
    this.toPersianNumbers = this.toPersianNumbers.bind(this);
    this.formatNumberWithCommas = this.formatNumberWithCommas.bind(this);
  }

  hideDialog() {
    this.setState({ showDriverNotifyModal: false });
  }

  //send info to customer
  handleSendSMS() {
    let order = this.props.selectedCustomer.orders[0];
    let { firstName, lastName, call } = this.props.selectedCustomer;
    if (call.charAt(0) !== "0") {
      call = "0" + call;
    }
    let payload = {
      phone: call,
      name: (firstName || "") + " " + (lastName || ""), //.replace(/\s/gi, " "),
      invoice_number: order.invoice_number || "نامشخص",
    };
    console.log("this.props.sendSMS", payload);
    this.props.sendSMS(payload);
    this.hideDialog();
  }

  //send request to driver for take order
  handleSendSMSSendRequestForDriver() {
    let driver = this.state.selectDriverSendRequest.value;
    let address = this.state.selectAddressSendRequest.value.address;
    address = address + "[ " + this.information.value + " ]";
    let name =
      (this.props.selectedCustomer.firstName || "") +
      " " +
      (this.props.selectedCustomer.lastName || "") +
      " " +
      (this.props.selectedCustomer.phone || "") +
      (this.props.selectedCustomer.phone ? "  و  " : "") +
      this.props.selectedCustomer.call;

    let { phone } = driver;
    let payload = {
      msg: {
        name,
        address,
      },
      phone,
    };

    this.props.sendDriverSMS(payload);
    this.setState({
      selectAddressSendRequest: undefined,
      selectDriverSendRequest: undefined,
      canSendRequest: false,
    });
    this.information.value = "";
  }

  componentDidMount() {}

  removeService(prop) {
    let { services } = this.state.order;
    let index = services.findIndex((s) => s.id == prop.id);
    this.setState({
      order: {
        ...this.state.order,
        services: [
          ...this.state.order.services.slice(0, index),
          ...this.state.order.services.slice(index + 1),
        ],
      },
    });
    NotificationManager.info("از لیست خدمات حذف شد", "حذف شد");
  }

  //save order
  handleChangeAddress(select) {
    this.setState({ selectAddress: select });
    this.setState({
      order: { ...this.state.order, address: select.value.address },
    });
    this.checkForCanSaveOrder();
  }

  //save order
  handleChangeDriver(select) {
    this.setState({ selectDriver: select });
    this.setState({ order: { ...this.state.order, driver: select.value } });
    this.checkForCanSaveOrder();
  }

  //send request to driver for collecting
  handleChangeAddressSendRequest(select) {
    this.setState(
      { selectAddressSendRequest: select },
      this.checkForCanSendRequest
    );
  }

  //send request to driver for collecting
  handleChangeDriverSendRequest(select) {
    this.setState(
      { selectDriverSendRequest: select },
      this.checkForCanSendRequest
    );
  }

  handleChangeService(select) {
    let canBeAdded = true;
    const { services } = this.state.order;
    /*
        //check if service exist so user can not add it 
        services.map((service) => {
            if (service.id == select.value.id) {
                canBeAdded = false;
                NotificationManager.warning('این سرویس قبلا انتخاب شده است.برای تغییر آن را از لیست خدمات حذف کنید', 'خطا')
            }
        });
        if (canBeAdded) {
            this.setState({ selectService: select })
            this.setState({ disabledServiceCount: false });
        }
        */

    this.setState({ selectService: select });
    this.setState({ disabledServiceCount: false });
  }

  //send request for driver
  checkForCanSendRequest() {
    console.log(this.state);
    if (
      this.state.selectDriverSendRequest &&
      this.state.selectAddressSendRequest
    ) {
      this.setState({ canSendRequest: true });
    } else {
      this.setState({ canSendRequest: false });
    }
  }

  //save order
  checkForCanSaveOrder(temp = false) {
    if (
      this.state.order.driver &&
      this.state.order.address &&
      (this.state.order.services.length > 0 || temp)
    ) {
      this.setState({ canSaveOrder: true });
    } else {
      this.setState({ canSaveOrder: false });
    }
  }

  generateOptionsFromDrivers(drivers) {
    let arr = [];
    for (let i = 0; i < drivers.length; i++) {
      if (drivers[i].isEnable)
        arr.push({
          value: drivers[i],
          label: drivers[i].firstName + " " + drivers[i].lastName,
        });
    }
    return arr;
  }

  generateOptionsFromServices(services) {
    return services.map((service) => ({
      value: service,
      label: `${service.name} -  قیمت: ${this.toPersianNumbers(
        this.formatNumberWithCommas(service.price)
      )} تومان , موجود: ${service.isDeleted ? "✗" : "✓"}`,
    }));
  }

  toPersianNumbers(num) {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return num.toString().replace(/\d/g, (x) => persianNumbers[x]);
  }

  formatNumberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  generateOptionsFromAddresses(addresses) {
    let arr = [];
    for (let i = 0; i < addresses.length; i++) {
      arr.push({
        value: addresses[i],
        label: addresses[i].address,
      });
    }
    return arr;
  }

  getRandom(length) {
    return Math.floor(
      Math.pow(10, length - 1) + Math.random() * 9 * Math.pow(10, length - 1)
    );
  }

  //create order and save it
  saveOrderBtn() {
    let order = this.createOrder();
    // this.props.addNewOrder({ _id: this.props.selectedCustomer._id }, order);

    window.server.emit(
      "add_order",
      this.props.selectedCustomer._id,
      order,
      (data) => {
        if (data.code == 200) {
          NotificationManager.success("سفارش با موفقیت ثبت شد", "انجام شد");
          this.setState({ showDriverNotifyModal: true });
          this.setState({
            selectedServiceCounter: 0,
            selectedServiceArea: 0,
            serviceTotalPrice: 0,
            selectAddress: {},
            selectDriver: {},
            selectService: {},
            invoice_number: 0,
            senfi_number: 0,
            transportation: 200000,
            order: {
              address: "",
              driver: {},
              services: [],
            },
            x: 0,
            y: 0,
            disabledServiceCount: true,
          });
          this.invoice_number.value = "";
          this.senfi_number.value = "";
          this.x.value = "";
          this.y.value = "";
          this.transportation.value = 200000;
          this.props.selectCustomer(JSON.parse(data.response));
        } else {
          NotificationManager.error(
            "مشکلی در ثبت سفارش.دوباره تلاش کنید",
            "خطا"
          );
        }
      }
    );
  }

  changeCounter(e) {
    this.setState({ selectedServiceCounter: e.target.value });
  }

  changeInvoiceNumber(e) {
    this.setState({ invoice_number: e.target.value });
  }

  changeTransportationValue(e) {
    this.setState({ transportation: parseFloat(e.target.value) });
  }

  changeSenfiNumber(e) {
    this.setState({ senfi_number: e.target.value });
  }

  changeArea(e) {
    this.setState({ selectedServiceArea: parseFloat(e.target.value) });
  }

  changeX(e) {
    this.setState({ x: parseFloat(e.target.value) });
    if (_.isNumber(parseFloat(this.y.value))) {
      this.area.value = parseFloat(this.x.value) * parseFloat(this.y.value);
      this.setState({ selectedServiceArea: this.area.value });
    }
  }

  changeY(e) {
    this.setState({ y: parseFloat(e.target.value) });

    if (_.isNumber(parseFloat(this.x.value))) {
      this.area.value = parseFloat(this.x.value) * parseFloat(this.y.value);
      this.setState({ selectedServiceArea: this.area.value });
    }
  }

  calculateAllServiceValues() {
    const { services } = this.state.order;
    let totalPrice = 0;
    services.map((service) => {
      totalPrice += service.price;
    });
    this.setState({ totalPrice: totalPrice });
  }

  setAddress(address) {
    this.setState({ order: { ...this.state.order, address: address.name } });
    NotificationManager.success("آدرس ذخیره شد", "انجام شد");
    //address fln ghabliat taghir nadare
  }

  addThisService(e) {
    e.preventDefault();
    let { selectService, selectedServiceCounter, selectedServiceArea } =
      this.state;
    let service = selectService.value;
    if (
      parseFloat(selectedServiceCounter) > 0 &&
      parseFloat(selectedServiceArea) > 0
    ) {
      service = {
        ...service,
        count: parseFloat(selectedServiceCounter),
        area: parseFloat(selectedServiceArea),
        total_price:
          parseFloat(selectedServiceCounter) *
          parseFloat(service.price) *
          parseFloat(selectedServiceArea),
      };
      this.setState({
        order: {
          ...this.state.order,
          services: [service, ...this.state.order.services],
        },
      });
      this.setState({
        selectService: {},
        disabledServiceCount: true,
        selectedServiceCounter: 0,
        selectedServiceArea: 0,
        x: 0,
        y: 0,
      });
      this.counter.value = "0";
      this.area.value = "0";
      this.x.value = "0";
      this.y.value = "0";
      NotificationManager.info("خدمات با موفقیت اضافه شد", "انجام شد");
      this.calculateAllServiceValues();
      this.checkForCanSaveOrder(true);
    } else {
      NotificationManager.error("تعداد و مساحت باید بیشتر از صفر باشد", "خطا");
    }
  }

  createOrder() {
    const { invoice_number, senfi_number, transportation } = this.state;
    const { address, services, driver } = this.state.order;
    return {
      id: this.getRandom(9),
      date: new Date(),
      code_senfi: senfi_number,
      address: address,
      senfi_number,
      invoice_number,
      transportation,
      services: services,
      total_price: (() => {
        let total = 0;
        services.forEach((service) => {
          total += service.count * service.price * service.area;
        });
        return total;
      })(),
      driver: driver,
      get stringDate() {
        return this.date.toISOString().substring(0, 10);
      },
    };
  }

  render() {
    return (
      <Row className="righter">
        <Col md={12}>
          <Card
            title="سفارش جدید"
            content={
              <div className="content">
                <form>
                  <Grid fluid>
                    <Row>
                      <Col
                        md={6}
                        style={{
                          border: "1px #e6e6e6 solid",
                          borderRadius: "4px",
                        }}
                      >
                        <Grid fluid>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <ControlLabel>خدمات</ControlLabel>
                                <Select
                                  value={this.state.selectService}
                                  onChange={this.handleChangeService}
                                  options={this.state.serviceOptions}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={12}>
                              <FormGroup>
                                <ControlLabel>واحد</ControlLabel>
                                <FormControl
                                  type="text"
                                  // value={this.state.customer.lastName}
                                  bsClass="form-control"
                                  placeholder="واحد"
                                  disabled={this.state.disabledServiceCount}
                                  inputRef={(ref) => {
                                    this.counter = ref;
                                  }}
                                  onFocus={() => (this.counter.value = "")}
                                  defaultValue={
                                    this.state.selectedServiceCounter
                                  }
                                  onChange={this.changeCounter}
                                />
                                <div style={{ marginTop: "10px" }} />
                                <ControlLabel>مساحت</ControlLabel>
                                <Row
                                  style={{
                                    paddingLeft: "10px",
                                    paddingRight: "10px",
                                  }}
                                >
                                  <Col sm={6}>
                                    <FormControl
                                      type="text"
                                      // value={this.state.customer.lastName}
                                      bsClass="form-control"
                                      placeholder="طول"
                                      disabled={this.state.disabledServiceCount}
                                      inputRef={(ref) => {
                                        this.x = ref;
                                      }}
                                      onFocus={() => (this.x.value = "")}
                                      defaultValue={this.state.x}
                                      onChange={this.changeX}
                                    />
                                  </Col>
                                  <Col sm={6}>
                                    <FormControl
                                      type="text"
                                      // value={this.state.customer.lastName}
                                      bsClass="form-control"
                                      placeholder="عرض"
                                      disabled={this.state.disabledServiceCount}
                                      inputRef={(ref) => {
                                        this.y = ref;
                                      }}
                                      onFocus={() => (this.y.value = "")}
                                      defaultValue={this.state.y}
                                      onChange={this.changeY}
                                    />
                                  </Col>
                                </Row>
                                <FormControl
                                  type="text"
                                  value={this.state.selectedServiceArea}
                                  bsClass="form-control"
                                  placeholder="مساحت"
                                  disabled={this.state.disabledServiceCount}
                                  inputRef={(ref) => {
                                    this.area = ref;
                                  }}
                                  // onFocus={() => (this.area.value = "")}
                                  defaultValue={this.state.selectedServiceArea}
                                  onChange={this.changeArea}
                                />
                              </FormGroup>
                              <Button
                                bsStyle="info"
                                disabled={this.state.disabledServiceCount}
                                onClick={this.addThisService}
                                pullRight
                                fill
                                type="button"
                              >
                                اضافه کردن
                              </Button>
                            </Col>
                          </Row>
                        </Grid>
                      </Col>
                      <Col xs={6}>
                        <Row style={{ padding: "5px" }}>
                          <Col xs={6}>
                            <FormGroup>
                              <ControlLabel>آدرس</ControlLabel>
                              <Select
                                value={this.state.selectAddress}
                                onChange={this.handleChangeAddress}
                                options={this.state.addressOptions}
                              />
                            </FormGroup>
                          </Col>
                          <Col xs={6}>
                            <FormGroup>
                              <ControlLabel>راننده</ControlLabel>
                              <Select
                                value={this.state.selectDriver}
                                onChange={this.handleChangeDriver}
                                options={this.state.driverOptions}
                              />
                            </FormGroup>
                          </Col>
                          <Col xs={6}>
                            <ControlLabel>شماره فاکتور</ControlLabel>
                            <FormControl
                              type="text"
                              // value={this.state.customer.lastName}
                              bsClass="form-control"
                              placeholder="شماره فاکتور"
                              inputRef={(ref) => {
                                this.invoice_number = ref;
                              }}
                              onFocus={() => (this.invoice_number.value = "")}
                              defaultValue={this.state.invoice_number}
                              onChange={this.changeInvoiceNumber}
                            />
                          </Col>

                          <Col xs={6}>
                            <ControlLabel>شماره صنفی</ControlLabel>
                            <FormControl
                              type="text"
                              // value={this.state.customer.lastName}
                              bsClass="form-control"
                              placeholder="شماره صنفی"
                              inputRef={(ref) => {
                                this.senfi_number = ref;
                              }}
                              onFocus={() => (this.senfi_number.value = "")}
                              defaultValue={this.state.senfi_number}
                              onChange={this.changeSenfiNumber}
                            />
                          </Col>
                          <Col xs={6}>
                            <ControlLabel>ایاب ذهاب</ControlLabel>
                            <FormControl
                              type="text"
                              // value={this.state.customer.lastName}
                              bsClass="form-control"
                              placeholder="ایاب ذهاب"
                              inputRef={(ref) => {
                                this.transportation = ref;
                              }}
                              onFocus={() => (this.transportation.value = "")}
                              defaultValue={this.state.transportation}
                              onChange={this.changeTransportationValue}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Grid>
                </form>

                <h4>خدمات</h4>
                <Table striped hover>
                  <thead>
                    <tr>
                      <th className="text-right">شماره</th>
                      <th className="text-right">نام</th>
                      <th className="text-right">قیمت واحد</th>
                      <th className="text-right">واحد</th>
                      <th className="text-right">مساحت</th>
                      <th className="text-right">قیمت کل</th>
                      <th className="text-right">حذف</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.order.services.map((prop, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            <PersianNumber>{key + 1}</PersianNumber>
                          </td>
                          <td>{prop.name}</td>
                          <td>
                            <PersianNumber>{prop.price || 0}</PersianNumber>
                          </td>
                          <td>
                            <PersianNumber>{prop.count || 0}</PersianNumber>
                          </td>
                          <td>
                            <PersianNumber>{prop.area || 0}</PersianNumber>
                          </td>
                          <td>
                            <PersianNumber>
                              {prop.total_price || 0}
                            </PersianNumber>
                          </td>
                          <td
                            style={{ cursor: "pointer" }}
                            className="text-warning"
                            onClick={() => this.removeService(prop)}
                          >
                            حذف{" "}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                <Button
                  bsStyle="info"
                  disabled={!this.state.canSaveOrder}
                  onClick={this.saveOrderBtn}
                  pullRight
                  fill
                  type="submit"
                >
                  ثبت سفارش
                </Button>
                <div className="clearfix" />
              </div>
            }
          />
        </Col>
        <Col md={12}>
          <Card
            title="ارسال درخواست"
            content={
              <div className="content">
                <form>
                  <Grid fluid>
                    <Row>
                      <Col xs={12}>
                        <Row style={{ padding: "5px" }}>
                          <Col xs={6}>
                            <FormGroup>
                              <ControlLabel>آدرس</ControlLabel>
                              <Select
                                value={
                                  this.state.selectAddressSendRequest
                                    ? this.state.selectAddressSendRequest
                                    : "انتخاب"
                                }
                                onChange={this.handleChangeAddressSendRequest}
                                options={this.state.addressOptions}
                              />
                            </FormGroup>
                          </Col>
                          <Col xs={6}>
                            <FormGroup>
                              <ControlLabel>راننده</ControlLabel>
                              <Select
                                value={
                                  this.state.selectDriverSendRequest
                                    ? this.state.selectDriverSendRequest
                                    : ""
                                }
                                onChange={this.handleChangeDriverSendRequest}
                                options={this.state.driverOptions}
                              />
                            </FormGroup>
                          </Col>
                          <Col xs={6}>
                            <ControlLabel>توضیحات</ControlLabel>
                            <FormControl
                              type="text"
                              // value={this.state.customer.lastName}
                              bsClass="form-control"
                              placeholder="توضیحات"
                              inputRef={(ref) => {
                                this.information = ref;
                              }}
                              onFocus={() => (this.information.value = "")}
                              defaultValue={this.state.information}
                              // onChange={this.changeMoreInformation}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Grid>
                </form>

                <Button
                  bsStyle="info"
                  disabled={!this.state.canSendRequest}
                  onClick={this.handleSendSMSSendRequestForDriver}
                  pullRight
                  fill
                  type="button"
                >
                  ارسال درخواست
                </Button>
                <div className="clearfix" />
              </div>
            }
          />
        </Col>

        <Modal
          show={this.state.show}
          onHide={this.handleHide}
          container={this}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">حذف راننده</Modal.Title>
          </Modal.Header>
          <Modal.Body>آیا میخواهید راننده انتخابی را حذف کنید ؟</Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleHide}>بستن</Button>
            <Button bsStyle="danger" onClick={this.handleRemove}>
              حذف
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showDriverNotifyModal}
          onHide={this.hideDialog}
          container={this}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">
              پیام به مشتری و راننده
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            آیا می‌خواهید این اطلاعات برای مشتری ارسال شود؟
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.hideDialog}>بستن</Button>
            <Button bsStyle="primary" onClick={this.handleSendSMS}>
              ارسال پیام
            </Button>
            <div style={{ marginTop: "15px" }}>
              <ClipLoader
                className={override}
                sizeUnit={"px"}
                size={40}
                color={"#123abc"}
                loading={this.props.SendSMS.fetching}
              />
            </div>
            {this.props.SendSMS.error
              ? " مشکلی در برقراری ارتباط " + this.props.SendSMS.error
              : () => this.hideDialog()}
          </Modal.Footer>
        </Modal>
      </Row>
    );
  }
}

const NewOrderConnect = connect(mapStateToProps, mapDispatchToProps)(NewOrder);

export default NewOrderConnect;
